/**
 *  @author:        Cloud for Good
 *  @description:   JavaScript Enhancement: Conditional Display of 'Skip to Search Results'
 *
 *  History
 *  <Date>        <Author Name>       <Reference #>       <Change Description>
 *  2024-12-30    Jassin Yacks (CFG)  CFG-488             Implemented JavaScript to hide the 'Skip to Search Results' option on non-search pages
*/

'use strict';

module.exports = function () {
    if ($('#searchresults').length === 0) {
        //remove the searchresults skip link from the page
        $('a[href*="searchresults"]').remove()
    }
}